import React from "react";
import Auth from '../../../routes/Auth';
import TopIcon from "../../../containers/assets/top-bar-expand.png";
import HeaderUserGroup from "./header-user-group";
import HeaderGameName from "./header-game-name";
import { view } from "@risingstack/react-easy-state";
import Avatar from "react-avatar";
import styled from 'styled-components';

const InstructorPageName = styled.b`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  color: #52c5cd;
`;

const LogoGroup = styled.div`
  background: #3a507b;
  width: 210px;
  height: 59px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 19px;

  ${p => p.isCollapsed && `
    justify-content: center;
    width: 66px;
    margin-right: 144px;
  `}
`;

const LogoIcon = styled.div`
  padding-left: 21px;
  cursor: pointer;

  ${p => p.isCollapsed && `
    padding-left: 0;
  `}
`;

const LogoText = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  color: #f5f6f7;

  ${p => p.isCollapsed && `
    display: none;
  `}
`;

function TopBar({
  isStudent,
  team_color,
  currentRound,
  roundInUrl,
  rounds,
  name,
  position,
  instructorTeams,
  isMenuExpanded,
  setMenuState,
}) {
  const temporaryUser = Auth.getTemporaryUser();
  let teamName = '';
  if (temporaryUser && instructorTeams) {
    const team = instructorTeams.find(i => Number(i.id) === Number(temporaryUser.team_id));
    teamName = team ? team.name : '';
  }

  return (
    <header className="header">
      <LogoGroup isCollapsed={!isMenuExpanded}>
        <LogoIcon
          isCollapsed={!isMenuExpanded}
          onClick={() => setMenuState(!isMenuExpanded)}
        >
          <img src={TopIcon} alt="expand" />
        </LogoIcon>
        <LogoText isCollapsed={!isMenuExpanded}>Market Games</LogoText>
      </LogoGroup>
      <div className="navbar-center">
        {isStudent && (
          <HeaderGameName
            team_color={team_color}
            currentRound={currentRound}
            roundInUrl={roundInUrl}
            rounds={rounds}
          />
        )}
        {!isStudent && (
          <InstructorPageName>Dashboard</InstructorPageName>
        )}
      </div>
      {isStudent && (
        <HeaderUserGroup
          team_color={team_color}
          name={name}
          position={position}
          isStudent={isStudent}
        />
      )}
      {temporaryUser && (
        <div className="header__user__group2">
          {" "}
          <Avatar name={teamName} color={team_color} size="50" round={true} />
          <p className="username">{teamName}</p>
        </div>
      )}
      {!temporaryUser && !isStudent && (
        <HeaderUserGroup
          team_color="#52c5cd"
          name={name}
          position={null}
          isStudent={isStudent}
        />
      )}
    </header>
  );
}

export default view(TopBar);



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/index.js